import { render, staticRenderFns } from "./dnsItems.vue?vue&type=template&id=5b825278"
import script from "./dnsItems.vue?vue&type=script&lang=js"
export * from "./dnsItems.vue?vue&type=script&lang=js"
import style0 from "./dnsItems.vue?vue&type=style&index=0&id=5b825278&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports